import { BookOpen, Calendar, Users } from "lucide-react";

function Stats() {
  return (
    <div className="bg-[#fdf8fe] text-[#380B46] lg:px-24 py-8 lg:py-12 flex justify-around items-center gap-4 flex-wrap">
      <div className="text-center px-2">
        <div className="flex justify-center mb-2 gap-3 items-center">
          <Calendar className="w-8 h-8" />
          <div className="font-bold text-xl lg:text-3xl">20+</div>
        </div>
        <div className="text-sm">Years teaching & mentoring</div>
      </div>

      <div className="text-center px-2">
        <div className="flex justify-center mb-2 gap-3 items-center">
          <Users className="w-8 h-8" />
          <div className="font-bold text-xl lg:text-3xl">Leaders</div>
        </div>
        <div className="text-sm">Coached across ministry & business</div>
      </div>

      <div className="text-center px-2">
        <div className="flex justify-center mb-2 gap-3 items-center">
          <BookOpen className="w-8 h-8" />
          <div className="font-bold text-xl lg:text-3xl">Books</div>
        </div>
        <div className="text-sm">& courses for faith, mindset & purpose</div>
      </div>
    </div>
  );
}

export default Stats;
